/**
 * Which candidate journeys are shown in a language other than English — a one-client special case.
 *
 * Ajanta Pharma Africa (org 6ad843905dc1476e61838161) asked for their "French Interview" screening
 * (job "Medical Representative - FLM - Africa") to be French end to end: apply, resume upload, hub,
 * assessment, AI interview and the closing pages. Every other screening stays English.
 *
 * A screening owns its own assessment and interview, so all three ids are listed: the assessment and
 * interview pages are often opened without the screening id in the URL.
 *
 * Keep in sync with server/modules/assessment/candidateLanguage.js (the passage-reading test).
 */
export const CANDIDATE_LANGUAGE_JOURNEYS = [
  {
    // Ajanta Pharma Africa — "French Interview"
    language: 'fr',
    screeningId: '6adb079ec806cba58eafd6ba',
    assessmentId: '6adb078f23e4ec9cfc4c2e52',
    interviewId: '6adb079dc806cba58eafd65e',
  },
];
